/** Year Neat Schedule launched — only update if the legal entity start year changes. */
export const NEAT_SCHEDULE_COPYRIGHT_START_YEAR = 2024;

/** Copyright year label; end year updates automatically each calendar year. */
export function getNeatScheduleCopyrightYears() {
  const currentYear = new Date().getFullYear();

  if (currentYear <= NEAT_SCHEDULE_COPYRIGHT_START_YEAR) {
    return String(currentYear);
  }

  return `${NEAT_SCHEDULE_COPYRIGHT_START_YEAR}–${currentYear}`;
}
